import {
  SELECT_FILTER,
  UPDATE_ORIGINAL_REVISION,
  UPDATE_MODIFIED_REVISION,
} from './constants'

const selectFilter = (filter) => {
  return {
    type: SELECT_FILTER,
    filter,
  }
}

const updateModifiedRevision = (projectId, revisionId) => ({
  type: UPDATE_MODIFIED_REVISION,
  projectId,
  revisionId
})

const updateOriginalRevision = (projectId, revisionId) => ({
  type: UPDATE_ORIGINAL_REVISION,
  projectId,
  revisionId
})

export {
  selectFilter,
  updateModifiedRevision,
  updateOriginalRevision,
}
